import { z } from 'zod';

export const invalidateDataGloballyActionSchema = z.enum(['privacyPreferencesUpdated', 'oneTimePromoRedeemed', 'userDataUpdated', 'notificationsBadgeCount']);

export type InvalidateDataGloballyAction = z.infer<typeof invalidateDataGloballyActionSchema>;
